// Module
var code = "<div class=\"dtp-ui-grid\"> <div id=\"skuGrid\" ag-grid=\"$ctrl.filterGridOptions\" class=\"ag-theme-balham\"></div> </div>";
// Exports
module.exports = code;